import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/95a73db6e6cad1c54622de2c17ca7476.jpg"
          alt="Adventure awaits"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#1A1A1A]/75"></div>
      </div>
      <div className="relative z-10 px-6 md:px-12 text-center">
        <p className="font-outfit text-[#C4FF61] text-xs uppercase tracking-[0.25em] mb-4">Limited Time</p>
        <h2 className="font-outfit font-black text-white text-4xl md:text-6xl leading-none mb-4">
          UP TO 30% OFF<br />
          <span className="text-[#C4FF61]">SUMMER SALE</span>
        </h2>
        <p className="font-inter text-white/60 text-base mb-8 max-w-md mx-auto">
          Stock up on premium outdoor gear before peak adventure season. Limited quantities available on select items.
        </p>
        <Link
          to="/products"
          className="inline-flex items-center gap-2 bg-[#C4FF61] text-[#1A1A1A] font-outfit font-bold px-10 py-4 rounded-full hover:bg-[#a8e84a] transition-colors cursor-pointer whitespace-nowrap"
        >
          Shop the Sale
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}
